import ProxyBase from '../../../../../core/proxies/ProxyBase'

class ScoreCompanyProxy extends ProxyBase {
  getRiskScaleInterpretation(params) {
    return this.get('RiskScaleInterpretation', params)
  }

  getHistoricalChangeDrdData(params) {
    return this.get('HistoricalChangeDrdData', params)
  }

  getHistoricalChange(params) {
    return this.get('HistoricalChange', params)
  }

  downloadHistoricalChange(params) {
    return this.get('HistoricalChange/ExportExcel', params, 'download')
  }

  getPDTermStructure(params) {
    return this.get('PDTermStructure', params)
  }

  getCommentary(params) {
    return this.get('Commentary', params)
  }

  getLinkageScore(params) {
    return this.get('LinkageScore', params)
  }

  downloadLinkageScore(params) {
    return this.get('LinkageScore/Export', params, 'download')
  }

  getDistributionScore(params) {
    return this.get('DistributionScore', params)
  }

  downloadDistributionScore(params) {
    return this.get('ExportDistributionScore', params, 'download')
  }

  getBreakdown(params) {
    return this.get('Breakdown', params)
  }

  getBreakdownCompare(params) {
    return this.get('BreakdownCompare', params)
  }

  getRiskDriverData(params) {
    return this.get('RiskDriverData', params)
  }

  downloadRiskDriverData(params) {
    return this.get('RiskDriverExport', params, 'download')
  }

  getRiskDriverCompare(params) {
    return this.get('RiskDriverCompare', params)
  }

  downloadRiskDriverCompareData(params) {
    return this.get('RiskDriverCompareExport', params, 'download')
  }
}

export default new ScoreCompanyProxy('Score/RiskScore/')
